export default {"src":"/_next/static/media/icons-search.b4d0b410.svg","height":24,"width":24};